import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 0;
  align-items: stretch;
`;

export const Cooldown = styled.span`
  color: #64748b;
  font-size: 0.85rem;
`;

export const ErrorText = styled.div`
  color: #ef4444;
  font-size: 0.85rem;
  text-align: center;
`;

export const ResendRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;

  & > button {
    background: none;
    border: none;
    padding: 0;
    color: #7469b6;
    text-decoration: underline;
    cursor: pointer;
    font: inherit;
  }

  & > button:disabled {
    color: #94a3b8;
    cursor: default;
    text-decoration: none;
  }
`;
